<nav class="navbar">
  <div class="spacer"></div>

  <div class="user-info" *ngIf="userEmail; else guest">
    <button type="button" class="user-menu-btn" [matMenuTriggerFor]="menuUsuario" aria-label="Menú de tu cuenta">
      <mat-icon aria-hidden="true">account_circle</mat-icon>
      <span class="user-email">{{ userEmail }}</span>
      <mat-icon aria-hidden="true">expand_more</mat-icon>
    </button>
    <mat-menu #menuUsuario="matMenu" xPosition="before">
      <a mat-menu-item routerLink="/mi-cuenta"><mat-icon>star</mat-icon>Mis estaciones</a>
      <a mat-menu-item routerLink="/mi-cuenta" fragment="consultas"><mat-icon>bookmarks</mat-icon>Mis consultas</a>
      <a mat-menu-item routerLink="/mi-cuenta" fragment="alertas"><mat-icon>notifications</mat-icon>Mis alertas</a>
      <!-- Solicitudes todavía no está habilitado: no reactivar sin pedido explícito.
      <a mat-menu-item routerLink="/mis-solicitudes"><mat-icon>assignment</mat-icon>Mis solicitudes</a>
      -->
      <a mat-menu-item routerLink="/admin" *ngIf="administrador"><mat-icon>admin_panel_settings</mat-icon>Administración</a>
      <button mat-menu-item type="button" (click)="logout()"><mat-icon>logout</mat-icon>Cerrar sesión</button>
    </mat-menu>
    <span *ngIf="emailSinConfirmar" class="email-aviso" role="status">
      <ng-container [ngSwitch]="reenvio">
        <ng-container *ngSwitchCase="'enviado'">Te reenviamos el correo de confirmación.</ng-container>
        <ng-container *ngSwitchCase="'error'">No se pudo reenviar; probá en unos minutos.</ng-container>
        <ng-container *ngSwitchDefault>
          Confirmá tu email.
          <button type="button" class="link-btn" (click)="reenviarVerificacion()" [disabled]="reenvio === 'enviando'">
            Reenviar correo
          </button>
        </ng-container>
      </ng-container>
    </span>
  </div>

  <ng-template #guest>
    <button class="btn" (click)="openAuthDialog()">Iniciar sesión</button>
  </ng-template>
</nav>